import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../../../shared/services/encripty-util.service';
import { Location } from '@angular/common';
import { CadastroVincularPrudutoService } from './cadastro-vincular-pruduto.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../../../shared/services/commom.service';
import { HttpParams } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import { ModalPrimeiraViaComponent } from '../../modal-primeira-via/modal-primeira-via.component';

@Component({
  selector: 'ngx-cadastro-vincular-produto',
  templateUrl: './cadastro-vincular-produto.component.html',
  styleUrls: ['./cadastro-vincular-produto.component.scss'],
})
export class CadastroVincularProdutoComponent implements OnInit {

  public formCadastrarLimite = null;
  public funcionarioId = null;
  public nome = null;
  public cpf = null;
  public status = null;
  public product = null;
  public limiteAtual = null;
  public saldoAtual = null;
  public limiteCredito = null;
  public isLimiteCredito = false;
  public isPercLiberado = false;
  public percentualLiberado = null;
  public produtoInfo = null;
  public balanceCardInfo = [];
  public listProdutos: any = null;
  public saldoConta = null;
  public saldoProximo = null;
  public saldoParcelado = null;
  public isSelecSaldo = true;
  public saldoGlobal = null;
  public bloqueioSaldo = null;
  public saldoGlobalSoma = null;
  public saldoContaSoma = null;
  // public saldoProxSoma = null;
  // public saldoParcSoma = null;
  public percpReuso30D = null;
  public percReusoParcelado = null;
  public percMaximoReuso = null;
  public percReusoVista = null;
  public percReusoParcela = null;
  public valorVia = null;
  public isSalario = false;
  public isCustoVia = false;
  public isCustoViaAdianta = false;
  public valorSolicitado = null;
  public isDisabledSaveButton: boolean = true;
  public customLogin = null;

  public resultadoSaldoAgiliza = null;
  public tarAgiliza = null;
  public saldoAgilizaSoma = null;
  public solicitacaoAutomaticaCartao = null;
  public listBandeiras: any = [];
  listBandeirasSelecionadas: Array<any> = [];
  public idProduct = null;
  public check = false;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private service: CadastroVincularPrudutoService,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private commomService: CommonService,
    private dialogService: NbDialogService,
  ) {

    this.produtoInfo = {
      id: this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id')),
      descricao: this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-description')),
      empresaCnpj: this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'))
    };

    this.spinnerService.show();

    this.atualizaSaldo();

    this.activatedRoute.queryParams.subscribe(params => {

      this.nome = this.encriptyService.decriptyBySecretKey(params.funcionarioNome);
      this.cpf = this.encriptyService.decriptyBySecretKey(params.funcionarioCpf);
      this.status = this.encriptyService.decriptyBySecretKey(params.status);
      this.funcionarioId = this.encriptyService.decriptyBySecretKey(params.funcionarioId);
      this.solicitacaoAutomaticaCartao = this.encriptyService.decriptyBySecretKey(params.solicitacaoAutomaticaCartao);
    });


  }

  salveProduto(data) {

    const status = this.status;
    const funcionarioId = this.funcionarioId;
    const product = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    data.status = status;
    data.funcionarioId = funcionarioId;
    data.product = product;

    if (this.idProduct == '8' || this.idProduct == '9') {

      this.listBandeirasSelecionadas = this.listBandeiras;

    }

    const register: any = {

      funcionarioId: data.funcionarioId,
      produtoId: data.product,
      saldoAtual: data.saldoAtual,
      salario: data.salario,
      percentualLiberado: data.percentualLiberado,
      limiteCredito: data.limiteCredito,
      status: data.status,
      valorGlobal: data.saldoGlobal,
      valorContaCorrente: data.saldoConta,
      valorRecebiveis: data.saldoAgiliza,
      valorRecebiveisParcelado: data.saldoParc,
      valorRecebiveis30dias: data.saldoProximos,
      bandeiras: this.listBandeirasSelecionadas
    };

    const saldoTotal = Number(data.saldoGlobal)
      + Number(data.saldoConta)
      + Number(data.saldoProximos)
      + Number(data.saldoParc)
      + Number(data.saldoAgiliza);

    if ((saldoTotal < this.valorVia && data.product == '3') || (!this.bloqueioSaldo && data.saldoAtual < this.valorVia)) {

      if (this.bloqueioSaldo) this.formCadastrarLimite.controls['saldoGlobal'].setValue(null);
      this.formCadastrarLimite.controls['saldoConta'].setValue(null);
      this.formCadastrarLimite.controls['saldoProximos'].setValue(null);
      this.formCadastrarLimite.controls['saldoParc'].setValue(null);
      this.notifications.warn('Não é possível salvar carga com saldo inferior ao custo da 1ª via!');

    } else {

      this.spinnerService.show();
      this.service.saveProductFunc(
        register,
        (resp) => {
          this.notifications.success('Registro Salvo com sucesso!');
          this.limparForm();
          this.spinnerService.hide();
          this.atualizaSaldo();
          this.buscaSaldoRecebiveis();
          this.location.back();
        }, (error) => {
          this.spinnerService.hide();
          this.notifications.error(error.message);
        });

    }

  }

  limparForm() {

    this.formCadastrarLimite = this.formBuilder.group({

      nome: [null],
      cpf: [null],
      salario: [null],
      limiteCredito: [null],
      percentualLiberado: [null],
      saldoGlobal: [null],
      saldoConta: [null],
      saldoParc: [null],
      saldoProximos: [null],
      saldoAgiliza: [null],
      custoVia: [null],

    });

  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      if (event.path[0].name == 'saldoGlobal') {
        this.formCadastrarLimite.controls['saldoGlobal'].setValue(null);
      }
      if (event.path[0].name == 'saldoConta') {
        this.formCadastrarLimite.controls['saldoConta'].setValue(null);
      }
      if (event.path[0].name == 'saldoAgiliza') {
        this.formCadastrarLimite.controls['saldoAgiliza'].setValue(null);
      }
      this.notifications.error('Não é permitido números negativos!');

    }
    return true;

  }

  getFormattedPrice(saldoAtual) {

    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(saldoAtual);
  }

  calcularLimite(data) {

    if (data.salario != null) {

      this.limiteCredito = (parseInt(data.salario) * (data.percentualLiberado) / 100);
      this.formCadastrarLimite.controls['limiteCredito'].setValue(this.limiteCredito);

    } else {

      this.notifications.error('Necessário digitar o Salário no campo Salário');

    }


  }

  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 97) && (charCode <= 122)) {
      return false;
    }
    return true;

  }

  ngOnInit() {

    this.buscaBandeiras();
    this.idProduct = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.isSelecSaldo = true;

    const cnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));
    const idProduto = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    let params = new HttpParams();

    if (idProduto != null) {
      params = params.append('idProduct', idProduto);
    }

    if (idProduto == 2) {
      this.isCustoViaAdianta = true
    } else {
      this.isCustoViaAdianta = false
    }

    if (cnpj != null) {
      params = params.append('cnpj', cnpj);
    }

    this.formCadastrarLimite = this.formBuilder.group({
      nome: [this.nome],
      cpf: [this.cpf],
      salario: [null],
      limiteCredito: [null],
      percentualLiberado: [null],
      saldoGlobal: [null],
      saldoConta: [null],
      saldoAgiliza: [null],
      saldoParc: [null],
      saldoProximos: [null],
      custoVia: [null],

    });


    this.formCadastrarLimite.controls['nome'].setValue(this.nome);

    this.formCadastrarLimite.controls['cpf'].setValue(this.cpf);

    this.service.taxasTermos(
      params,
      (response) => {
        this.bloqueioSaldo = response;
        this.isSelecSaldo = true;
        document.getElementById('salario').setAttribute('disabled', 'false');
        if (!this.bloqueioSaldo) this.isDisabledSaveButton = false;
        let params2 = new HttpParams();
        if (this.bloqueioSaldo === true) {
          params2 = params2.append('isReusoCorporativo', 'true');
        }

        this.buscaSaldoRecebiveis();

        this.service.buscaLimiteGlobal(params2, (response) => {


          if (this.produtoInfo.descricao == 'ADIANTA') {
            this.isSalario = true;
            this.isCustoVia = false;
            this.limiteAtual = response.limiteAtual;
            this.isLimiteCredito = true;
            this.isPercLiberado = true;
            //this.isSelecSaldo = false;
            document.getElementById('salario').removeAttribute('disabled');
            this.isDisabledSaveButton = false;

            this.commomService.buscaProdutos().subscribe(response => {
              this.listProdutos = response;
              this.listProdutos.forEach(produto => {
                if (produto.produtoDescricao == 'ADIANTA') {

                  produto['taxaDescricao'] = 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO';
                  this.balanceCardInfo.push({
                    'label': produto.produtoDescricao,
                    'descricao': produto.produtoDescricao,
                    'saldoAtual': produto.limiteGlobalAtual,
                    'custoImportacao': 0,
                    'icon': 'far fa-money-bill-alt',
                    'type': 'primary',
                    'selected': false,
                    'taxaDescricao': 'TARIFA_EMISSAO_USUARIO_CONVENIO_BANDEIRADO',

                  });
                }
              });
            });
          } else {
            this.isCustoVia = true;
            this.isSalario = false;
            this.saldoAtual = response.saldoAtual;
            this.saldoConta = response.saldoContaCorrente;
            // this.saldoProximo = response.saldo30dias;
            // this.saldoParcelado = response.saldoMaior30dias;
            this.percpReuso30D = response.percReuso30D;
            this.percMaximoReuso = response.percMaximoReuso;
            this.percReusoParcelado = response.percReusoParcelado;
            // this.percReusoParcelado = response.percReusoParcelado;
            this.isLimiteCredito = false;
            this.isPercLiberado = false;

            this.commomService.buscaProdutos().subscribe(response => {

              this.listProdutos = response;
              this.listProdutos.forEach(produto => {
                if (produto.produtoId == idProduto) {

                  if (produto.produtoDescricao == 'PAGAMENTO') {

                    produto['taxaDescricao'] = 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS';
                    this.balanceCardInfo.push({
                      'label': produto.produtoDescricao,
                      'descricao': 'SALARIO',
                      'saldoAtual': produto.saldoGlobalAtual,
                      'custoImportacao': 0,
                      'icon': 'fas fa-coins',
                      'type': 'danger',
                      'selected': false,
                      'taxaDescricao': 'TARIFA_EMISSAO_PLATAFORMA_PAGAMENTOS',
                      isPagamento: true,
                      saldoConta: this.saldoConta == null ? 0 : this.saldoConta,
                      saldoProximo: this.saldoProximo == null ? 0 : this.saldoProximo,
                      saldoParcelado: this.saldoParcelado == null ? 0 : this.saldoParcelado,
                    });
                  } else if (produto.produtoDescricao == 'ALIMENTACAO_BANDEIRADO') {

                    produto['taxaDescricao'] = 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO';
                    this.balanceCardInfo.push({
                      'label': 'ALIMENTAÇÃO',
                      'descricao': 'ALIMENTAÇÃO',
                      'saldoAtual': produto.saldoGlobalAtual,
                      'custoImportacao': 0,
                      'icon': 'fas fa-address-card',
                      'type': 'danger',
                      'selected': false,
                      'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO',
                      isPagamento: true,
                      saldoConta: this.saldoConta == null ? 0 : this.saldoConta,
                      saldoProximo: this.saldoProximo == null ? 0 : this.saldoProximo,
                      saldoParcelado: this.saldoParcelado == null ? 0 : this.saldoParcelado,
                    });
                  } else if (produto.produtoDescricao == 'REFEICAO_BANDEIRADO') {
                    produto['taxaDescricao'] = 'TARIFA_DE_EMISSAO_DE_CARTAO_REFEICAO';
                    this.balanceCardInfo.push({
                      'label': 'REFEIÇÃO',
                      'descricao': 'REFEIÇÃO',
                      'saldoAtual': produto.saldoGlobalAtual,
                      'custoImportacao': 0,
                      'icon': 'fas fa-id-card',
                      'type': 'info',
                      'selected': false,
                      'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_REFEICAO',
                      isPagamento: true,
                      saldoConta: this.saldoConta == null ? 0 : this.saldoConta,
                      saldoProximo: this.saldoProximo == null ? 0 : this.saldoProximo,
                      saldoParcelado: this.saldoParcelado == null ? 0 : this.saldoParcelado,
                    });
                  } else if (produto.produtoDescricao == 'FLEXIVEL') {

                    //produto['taxaDescricao'] = 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO';
                    this.balanceCardInfo.push({
                      'label': 'FLEXÍVEL',
                      'descricao': 'FLEXÍVEL',
                      'saldoAtual': produto.saldoGlobalAtual,
                      'custoImportacao': 0,
                      'icon': 'fas fa-money-check',
                      'type': 'info',
                      'selected': false,
                      //'taxaDescricao': 'TARIFA_DE_EMISSAO_DE_CARTAO_ALIMENTACAO',
                      isPagamento: true,
                      saldoConta: this.saldoConta == null ? 0 : this.saldoConta,
                      saldoProximo: this.saldoProximo == null ? 0 : this.saldoProximo,
                      saldoParcelado: this.saldoParcelado == null ? 0 : this.saldoParcelado,
                    });
                  }
                }
              });

            });
            if (this.saldoAtual == '0') {
              document.getElementById('saldoGlobal').setAttribute('disabled', 'false');
            }
            if (this.saldoConta == '0' && (this.bloqueioSaldo == true)) {
              document.getElementById('saldoConta').setAttribute('disabled', 'false');
            }

            if (this.resultadoSaldoAgiliza == '0' && (this.bloqueioSaldo == true)) {
              document.getElementById('saldoAgiliza').setAttribute('disabled', 'false');
            }
          }

          this.getFormattedPrice(this.limiteAtual);
          this.spinnerService.hide();

        }, (error) => {
          this.notifications.error(error.message);
          this.spinnerService.hide();
        });
      }, (error) => {
        this.notifications.error(error.response.msgRetorno);
      });

    this.spinnerService.show();

    this.buscaTaxa();
    //this.fillProductRate();

  }

  fillProductRate() {

    let params = new HttpParams();
    params = params.append('rateDescription', 'TARIFA_DE_EMISSAO_DE_CARTAO_REFEICAO');
    this.service.findEnterpriseRates(params,
      (response) => {
        this.valorVia = response[0].valor;
        this.formCadastrarLimite.controls['salario'].setValue(this.valorVia);

      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  calcEmitFirstLabelCopy(listBandeirasSelecionadas: Array<any>) {

    let produtoId = this.produtoInfo.id;

    let listBandeiraId: Array<any> = listBandeirasSelecionadas.map((bandeira) => bandeira.id);
    let listBandeiraIdString: string = '';

    for (let bandeiraId of listBandeiraId) {
      listBandeiraIdString = listBandeiraIdString + bandeiraId + ','
    }

    listBandeiraId.map(bandeiraId => listBandeiraIdString + bandeiraId + ',');
    listBandeiraIdString = listBandeiraIdString.slice(0, -1);

    let params = new HttpParams();
    params = params.append('produtoId', produtoId);
    params = params.append('listBandeiraId', listBandeiraIdString);
    this.service.ratesEmitFirstLabelCopy(params,
      (response) => {
        if (response.length == 0) {
          this.valorVia = 0;
          if (produtoId == 2) {
            this.formCadastrarLimite.controls['salario'].setValue(null);
            this.formCadastrarLimite.controls['custoVia'].setValue(this.valorVia);
          } else {
            this.formCadastrarLimite.controls['salario'].setValue(this.valorVia);
          }
        } else {
          this.valorVia = response.reduce((prevVal, historico) => {
            return prevVal + historico.valor;
          }, 0);
          if (produtoId == 2) {
            this.formCadastrarLimite.controls['salario'].setValue(null);
            this.formCadastrarLimite.controls['custoVia'].setValue(this.valorVia);
          } else {
            this.formCadastrarLimite.controls['salario'].setValue(this.valorVia);
          }
        }


      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }


  viewcompararSaldo(data) {

    const saldoTotal = Number(this.saldoAtual)
      + Number(this.saldoConta) + Number(this.saldoProximo) + Number(this.saldoParcelado);

    if (data > saldoTotal) {
      this.notifications.warn('Valor carga maior que o saldo disponível');
      this.formCadastrarLimite.controls['salario'].setValue(null);
    }

  }

  viewSaldoConsumido(data, element) {

    const valorTotal = this.removerMascaraMoeda(data);
    let valorCarga = 0;

    if (element.name === 'saldoGlobal') {
      this.saldoGlobalSoma = valorTotal;
      valorCarga = Number(this.saldoGlobalSoma)
        + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
      if ((valorTotal > this.saldoAtual) || (valorCarga > this.valorVia)) {
        this.saldoGlobalSoma = 0;
        this.notifications.warn('Saldo Global maior que o custo da 1ª Via :' + valorCarga + 'e ' + this.valorVia);
        this.formCadastrarLimite.controls['saldoGlobal'].setValue(null);
      }
    }
    if (element.name === 'saldoConta') {
      this.saldoContaSoma = valorTotal;
      valorCarga = Number(this.saldoGlobalSoma)
        + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
      if ((valorTotal > this.saldoConta) || (valorCarga > this.valorVia)) {
        this.saldoContaSoma = 0;
        this.notifications.warn('Saldo Conta Corrente maior que o custo da 1ª Via');
        this.formCadastrarLimite.controls['saldoConta'].setValue(null);
      }
    }
    if (element.name === 'saldoAgiliza') {
      const somaSaldos = Number(this.saldoProximo) + Number(this.saldoParcelado);

      this.saldoAgilizaSoma = valorTotal;
      if (valorTotal > somaSaldos) {
        this.saldoAgilizaSoma = 0;
        this.notifications.warn('Saldo Agilliza não é suficiente');
        this.formCadastrarLimite.controls['saldoAgiliza'].setValue(null);
      }
    }

    valorCarga = Number(this.saldoGlobalSoma)
      + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
    this.valorSolicitado = valorCarga;

    if (this.valorVia === this.valorSolicitado) {
      this.isDisabledSaveButton = false;
    } else {
      this.isDisabledSaveButton = true;
    }
  }

  buscaTaxa() {

    this.service.buscarTaxaAgiliza(null, (response) => {
      this.tarAgiliza = response;
    }, null);

  }

  removerMascaraMoeda(data: string) {

    let value: any = data.replace('R$', '');

    if (value.length < 13) {
      value = value.replace('.', '');
      value = value.replace(',', '.');
      value = value.trim();
    } else {
      value = value.replace('.', '');
      value = value.replace('.', '');
      value = value.replace(',', '.');
      value = value.trim();
    }

    return Number(value);
  }

  previousPage() {
    this.location.back();
  }

  saldoProximos30() {

    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoProximos',
      },
    });
  }

  saldoAgiliza() {

    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoAgiliza',
      },
    });
  }

  saldoParc() {

    this.dialogService.open(ModalPrimeiraViaComponent, {
      context: {
        nome: 'saldoParc',
      },
    });
  }


  validAllValue(data, element) {
    const valorTotal = this.removerMascaraMoeda(data);
    let valorCarga = 0;

    switch (element.name) {
      case 'saldoGlobal':
        this.saldoGlobalSoma = valorTotal;
        valorCarga = Number(this.saldoGlobalSoma)
          + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
        break;
      case 'saldoConta':
        this.saldoContaSoma = valorTotal;
        valorCarga = Number(this.saldoGlobalSoma)
          + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
        break;
      case 'saldoAgiliza':
        this.saldoAgilizaSoma = valorTotal;
        valorCarga = Number(this.saldoGlobalSoma)
          + Number(this.saldoContaSoma) + Number(this.saldoAgilizaSoma);
        break;
    }
    this.valorSolicitado = valorCarga;
    this.isDisabledSaveButton = !(this.valorVia === this.valorSolicitado);
  }

  buscaBandeiras() {

    this.service.buscaBandeiras(this.produtoInfo.empresaCnpj, this.produtoInfo.id, null, (response) => {

      this.listBandeiras = response;
      this.selecionarBandeira(response)

    }, (error) => {
      this.notifications.error(error.message);
    });
  }


  selecionarBandeira(bandeira) {

    for (let i = 0; i < bandeira.length; i++) {

      if (bandeira[i].id != null) {
        let listBandeirasSelecionadasFilter: Array<any> =
          this.listBandeirasSelecionadas.filter(bandeiraFilter => bandeiraFilter.id === bandeira[i].id);
        if (listBandeirasSelecionadasFilter.length == 0) {
          this.listBandeirasSelecionadas.push(bandeira[i]);
        }
      } else {
        this.listBandeirasSelecionadas =
          this.listBandeirasSelecionadas.filter(bandeiraFilter => bandeiraFilter.id !== bandeira[i].id);
      }

    }

    if (this.idProduct == '8' || this.idProduct == '9') {

      this.check = true
      this.calcEmitFirstLabelCopy(this.listBandeiras);
      this.isDisabledSaveButton = false;
    }

    this.calcEmitFirstLabelCopy(this.listBandeirasSelecionadas);
  }

  atualizaSaldo() {
    let params = new HttpParams();
    if (this.bloqueioSaldo === true) {
      params = params.append('isReusoCorporativo', 'true');
    }
    this.service.buscaLimiteGlobal(params, (response) => {

      if (this.produtoInfo.descricao === 'ADIANTA') {
        this.limiteAtual = response.limiteAtual;
        this.isLimiteCredito = true;
        this.isPercLiberado = true;
        //this.formCadastrarLimite.controls['saldoAtual'].setValue(this.limiteAtual);
      } else {
        this.saldoAtual = response.saldoAtual;
        this.isLimiteCredito = false;
        this.isPercLiberado = false;
        if (this.formCadastrarLimite.controls['saldoAtual'] != null) {
          this.formCadastrarLimite.controls['saldoAtual'].setValue(this.saldoAtual);
        }
      }

      this.getFormattedPrice(this.limiteAtual);
      this.spinnerService.hide();

    }, (error) => {
      this.notifications.error(error.message);
      this.spinnerService.hide();
    });
  }

  buscaSaldoRecebiveis() {

    this.service.buscaSaldoRecebiveis(null, (res) => {

      if (res != null) {
        this.saldoProximo = res.saldo30dias != null ? res.saldo30dias : 0;
        this.saldoParcelado = res.saldoMaior30dias != null ? res.saldoMaior30dias : 0;
        this.resultadoSaldoAgiliza = Number(this.saldoProximo) + Number(this.saldoParcelado);
      }

    }, null);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }


}
